import {
  displayXl,
  displayLg,
  displayMd,
  displaySm,
  displayXs,
  headingXl,
  headingLg,
  headingMd,
  headingSm,
  labelLg,
  labelMd,
  labelSm,
  labelButtonMd,
  labelButtonSm,
  labelOverline,
  bodyLg,
  bodyMd,
  bodySm,
  bodyXs,
} from '@achieve/ascend/dist/styles/typography/index.js'

const fontTypes = {
  displayXl,
  displayLg,
  displayMd,
  displaySm,
  displayXs,
  headingXl,
  headingLg,
  headingMd,
  headingSm,
  labelLg,
  labelMd,
  labelSm,
  labelButtonMd,
  labelButtonSm,
  labelOverline,
  bodyLg,
  bodyMd,
  bodySm,
  bodyXs,
}

export { fontTypes }
export default fontTypes
